module.exports = __webpack_public_path__ + "img/16581271_L.49439357.png";